import { Isometry }    from 'components/Isometry/Isometry'
import { ParentIsometry } from 'components/Isometry/ParentIsometry';
import { SeasonIsometry } from 'components/Isometry/SeasonIsometry';
import { IsometrySub } from 'components/Isometry/Subisometry'
import { useBreak } from 'hooks/useBreak';
import { useAtom } from 'jotai';
import { useParams }   from 'react-router-dom'
import {  toggle_drawer } from 'state/actions';
import { get, useGet } from 'state/jotai';
import { seasonMode, vis_desktop_nav, vis_detail, vis_filter } from 'state/store.global';
import { _parentIsometry } from 'state/store.parentIsometry';

export const ViewIsometry = () => {
  const isDesktop    = useBreak("md_up");
  const detailDrawer = useAtom(vis_detail)[0];
  const toggle = useAtom(toggle_drawer)[1];
  const isometryToggle     = get(_parentIsometry, 'toggle');
  const sub = useParams('sub').sub
  
  const [, setShowFilter] = useAtom(vis_filter);
  const [, setShowMenu] = useAtom(vis_desktop_nav);

  const isSeasonModeOn = useGet(seasonMode);

 

  return (
    <>
      <div style={{border:'0px solid gray',height: isDesktop ? 'calc(100vh - 158px)' : '100%',position:'relative'}} onClick={()=> {
        
        detailDrawer && toggle("detail")
        setShowFilter(false);
        setShowMenu(false);
    
    }}>
        {/* { !sub && <Isometry/> }
        { sub  && <IsometrySub sub={sub}/> } */}
              {/* { isSeasonModeOn ? <SeasonIsometry /> : isometryToggle ? <ParentIsometry />  : <Isometry/> } */}
                 <Isometry/>
      </div>
    </>
  )
}